<!--FastBI产品-->
<template>
  <div class="home-main af_cloud clearfix">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">安捷云本地化产品</span> <span class="title-en">/AF localizedProducts</span>
        <div class="main-title-right" v-loading="loading">
          <el-button size="medium" class="danger" @click="triallDialogOpen">客户试用</el-button>
          <el-button size="medium" class="primary" @click="buyFirstDialogOpen">客户购买</el-button>
        </div>
      </div>
      <!--筛选部分start-->
      <div class="product-selector_main">
        <div class="selector-left_main">
          <!-- <div class="selector-item">
            <span class="demonstration" style="width: 60px;">过期时间</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateStart" type="date" align="right"
              :picker-options="pickerOptions1" size="small">
            </el-date-picker>
            <span class="demonstration" style="padding: 5px;">到</span>
            <el-date-picker value-format="yyyy-MM-dd" v-model="searchOption.openingDateEnd" type="date" align="right"
              :picker-options="pickerOptions2" size="small">
            </el-date-picker>
          </div> -->
          <div class="selector-item">
            <span class="title" style="width: 60px;">授权码</span>
            <el-input v-model="searchOption.code" size="small" clearable></el-input>
          </div>
          <div class="selector-item">
            <span class="title" style="width: 70px;">企业名称</span>
            <el-input v-model="searchOption.name" size="small" clearable></el-input>
          </div>
          <div class="selector-item">
            <span class="title" style="width: 100px;">归属伙伴用户</span>
            <el-input v-model="searchOption.username" size="small" clearable></el-input>
          </div>
        </div>
        <div class="selector-right_main">
          <div class="buttons">
            <el-button size="small" class="warning" @click="search">搜索</el-button>
            <el-button size="small" @click="restSearch">重置</el-button>
          </div>

        </div>
      </div>
      <!--筛选部分end-->

      <div class="product-main-line"></div>

      <!--产品列表start-->
      <div class="product-main-list">
        <el-table :data="tableData" height="100%" style="width: 100%" stripe>
          <el-table-column width="20"> </el-table-column>
          <el-table-column label="企业授权码">
            <template slot-scope="scope">
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业联系人">
            <template slot-scope="scope">
              <span>{{ scope.row.contact_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.mobile }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="过期时间">
            <template slot-scope="scope">
              <span>{{ scope.row.expire_time }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{ getAuthStatus(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="归属伙伴用户名">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row ? scope.row.user.username : "" }}</span> -->
              <span>{{ scope.row ? scope.row.user_loginname : "" }}</span>

            </template>
          </el-table-column>
          <el-table-column label="归属伙伴名称">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row ? scope.row.user.real_name : "" }}</span> -->
              <span>{{ scope.row ? scope.row.user_loginname : "" }}</span>

            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.note }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="300" class="table-status">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.status == 3">
                <el-button v-if="isShowDelayBtn(scope.$index, scope.row)" size="mini" type="primary"
                  @click="delayClick(scope.$index, scope.row)">延期</el-button>
              </span> -->
              <el-button size="mini" type="primary" @click="purchaseView(scope.$index, scope.row)">购买查看</el-button>
              <el-button size="mini" type="primary" @click="buyProduct(scope.$index, scope.row)">购买应用</el-button>
              <el-button size="mini" type="primary" @click="editPasswordOpen(scope.$index, scope.row)">修改密钥</el-button>
              <el-button size="mini" type="primary" @click="editCustomerOpen(scope.$index, scope.row)">编辑备注</el-button>
              <el-button size="mini" v-if="is_superuser" type="primary"
                @click="authorizationTransfer(scope.$index, scope.row)">授权转移</el-button>
              <!-- <el-button size="mini" v-if="is_superuser" type="primary"
                @click="authorizationTransfer(scope.$index, scope.row)">授权转移</el-button>
              <el-button v-if="scope.row.status === 3 && is_superuser" size="mini" type="primary"
                @click="trialExtension(scope.$index, scope.row)">试用延期</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pagination.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
      <!--产品列表end-->


    </div>
    <buyDialog ref="buyDialog"></buyDialog>
    <transferDialog ref="transferDialog"></transferDialog>
    <extensionDialog ref="extensionDialog"></extensionDialog>


    <!-- 购买查看 -->
    <el-drawer title="" :visible.sync="drawer" ref="drawerRef" size="70%">

      <div class="drawer_main">
        <div class="title_main">
          <div class="title_top">
            <span>{{ currentOrg ? currentOrg.name : "" }}</span>
          </div>
          <div class="title_mid">
            <div class="item">
              <span style="width: 90px;">企业授权码：</span>
              <span>{{ currentOrg ? currentOrg.code : "" }}</span>
            </div>
            <div class="item">
              <span style="width: 90px;">企业联系人：</span>
              <span>{{ currentOrg ? currentOrg.contact_name : "" }}</span>
            </div>
            <div class="item">
              <span style="width: 80px;">联系电话：</span>
              <span>{{ currentOrg ? currentOrg.mobile : "" }}</span>
            </div>
            <div class="item">
              <span style="width: 80px;">创建时间：</span>
              <span>{{ currentOrg ? currentOrg.create_time : "" }}</span>
            </div>
          </div>
          <div class="title_bottom">
            <span>备注：</span>
            <span>{{ currentOrg ? currentOrg.note : "" }}</span>
          </div>

        </div>
        <div class="table_main">
          <el-tabs v-model="activeName">
            <el-tab-pane label="已购应用" name="first">
              <el-table :data="purchasedProjects" height="100%" style="width: 100%" v-loading="ordersModulesLoading">
                <!-- <el-table-column width="100" label="模块类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.type == 1 ? '应用' : '流量包' }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column prop="app_name" width="300" label="应用名称">
                  <template slot-scope="scope">
                    <span>{{ scope.row.app_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column width="100" label="授权状态">
                  <template slot-scope="scope">
                    <span>{{ scope.row.status == 0 ? '正式' : '试用' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="开通时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.create_time }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="到期时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.expire_time }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.status != 0 && is_superuser" size="mini" type="text"
                      @click="trialAppExtension(scope.$index, scope.row)">延期</el-button>
                    <el-button v-if="scope.row.expire_time != '买断'" size="mini" type="text"
                      @click="buyProduct1(scope.$index, scope.row, 'module_buy')">购买</el-button>
                  </template>
                </el-table-column>

              </el-table>
            </el-tab-pane>
            <el-tab-pane label="订单列表" name="second">
              <div style="display: flex;height: 100%;flex-direction: column;">
                <div style="height: calc(100% - 32px);">
                  <el-table :data="orderList" height="100%" style="width: 100%" v-loading="ordersModulesLoading">
                    <el-table-column label="订单号">
                      <template slot-scope="scope">
                        <span>{{ scope.row.code }}</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="购买版本">
                      <template slot-scope="scope">
                        <span>{{ scope.row.edition ? scope.row.edition : "" }}</span>
                      </template>
                    </el-table-column> -->
                    <el-table-column label="购买应用">
                      <template slot-scope="scope">
                        <span>{{ scope.row.afapp_auth ? scope.row.afapp_auth.app_name : "" }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="80" label="购买时长">
                      <template slot-scope="scope">
                        <span>{{ getYears(scope.row.months) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="100" label="订单金额">
                      <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单日期">
                      <template slot-scope="scope">
                        <span>{{ scope.row.create_time }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单备注">
                      <template slot-scope="scope">
                        <span>{{ scope.row.note }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="pagination">
                  <el-pagination :disabled="!orderPagination.use" @size-change="handleSizeChangeOrder"
                    @current-change="handleCurrentChangeOrder" :current-page="orderPagination.currentPage"
                    :page-sizes="[20, 30, 50, 100]" :page-size="orderPagination.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="orderPagination.total">
                  </el-pagination>
                </div>
              </div>

            </el-tab-pane>
          </el-tabs>
        </div>

      </div>
    </el-drawer>
    <!-- 编辑备注 -->
    <el-dialog :before-close="restEditCustomerForm" title="编辑备注" :visible.sync="editCustomerDialog" width="510px"
      class="editCustomerDialog">
      <el-form :model="editCustomerForm" ref="editCustomerForm">

        <el-form-item label="企业名称" prop="name" :label-width="'100px'">
          <el-input v-model="editCustomerForm.name" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="企业授权码" prop="code" :label-width="'100px'">
          <el-input v-model="editCustomerForm.code" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label-width="'100px'" label="备注" prop="note">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="editCustomerForm.note"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('editCustomerForm', (editCustomerDialog = false))">取 消</el-button>
        <el-button class="primary" @click="editCustomerSubmit">保 存</el-button>
      </div>
    </el-dialog>

    <!--编辑授权账号信息start-->
    <el-dialog :before-close="restEditPasswordForm" title="修改密码" :visible.sync="editPasswordDialog" width="510px"
      class="editCustomerDialog">
      <el-form :model="editPasswordForm" ref="editPasswordForm" :rules="editPasswordFormRules">

        <el-form-item label="企业名称" prop="name" :label-width="'100px'">
          <el-input v-model="editPasswordForm.name" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="企业授权码" prop="code" :label-width="'100px'">
          <el-input v-model="editPasswordForm.code" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass" :label-width="'100px'">
          <el-input show-password v-model="editPasswordForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass" :label-width="'100px'">
          <el-input show-password v-model="editPasswordForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('editCustomerForm', (editPasswordDialog = false))">取 消</el-button>
        <el-button class="primary" @click="editPasswordSubmit">保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import buyDialog from './buyLocal.vue';

import transferDialog from './transferDialog.vue';
import extensionDialog from './extensionDialog.vue';


import { isvalidPhone } from '@/assets/js/validate';
import { getAFLocalList, AFLocalUpdate, AFLocalDelay, getAFOrdersApps } from "@/api/afLocal"
import { getOrderByParam } from "@/api/order"

import { createGetUrlParams } from '@/utils/url';
import { authStatus, edition } from '@/utils/dataDict';
import { payVerify } from '@/utils/pay';
import { seriesName, version } from './utils';
export default {
  data() {
    //手机号验证
    let validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入电话号码'));
      } else if (!isvalidPhone(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };
    //两次密码是否相等
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changKeyForm.newPassword) {
        callback(new Error('两次输入密码请保持一致!'));
      } else {
        callback();
      }
    };

    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.editPasswordForm.checkPass !== '') {
          this.$refs.editPasswordForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.editPasswordForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      drawer: false,
      offlineDialog: false, //离线授权
      fastbiEditions: [],
      currentEdition: '',
      meEdition: edition[1],
      purchasedProjects: [],  //已购项目
      orderList: [], //订单列表
      verifyCodeResult: {
        //接收效验code是否已存在结果
        success: false,
        loading: false,
        icon: '',
      },
      pagination: {
        use: true,
        total: 0,
        size: 20,
        currentPage: 1,
      },
      orderPagination: {
        use: true,
        total: 0,
        size: 50,
        currentPage: 1,
      },
      codeLoading: false,
      curentId: 0, //选中表格行的id
      currentIndex: 0, //选中表格行的元素下标
      payTableShow: false,
      payTableData: [], //支付所需价格表
      payData: '', //需要支付的数据
      payBtnShow: false,
      alertType: 'success',
      payDescription: '',
      /*筛选条件*/
      searchOption: {
        openingDateStart: '', //选择开通时间-开始
        openingDateEnd: '', //选择开通时间-结束
        name: '', //选择授权客户
        code: '', //选择授权码
        username: ""
      },

      /*开通时间start*/
      pickerOptions1: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近90天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近1年',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      /*开通时间end*/

      /*过期时间start*/
      pickerOptions3: {
        shortcuts: [
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      pickerOptions4: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
          {
            text: '30天后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      /*过期时间end*/

      /*表格数据start*/
      tableData: [],
      /*表格数据end*/

      formLabelWidth: '125px',
      editionDict: {
        1: '小智报表高级版',
        101: '小智BI高级版',
      },
      /*产品试用start*/
      triallDialog: false,
      FBITriallDateValue: '',
      triallForm: {
        code: '', //试用产品授权码
        key: '', //试用产品授权密码
        name: '', //试用产品公司名称
        contact_name: '', //试用产品联系人
        //user_count: 1,
        phone: '', //试用产品联系电话
        email: '', //试用产品联系邮箱
        trail_days: 30,
        fbi_edition: 1,
      },
      triallFormRules: {
        code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        user_count: [{ type: 'number', message: '请输入数字' }],
        key: [
          {
            required: true,
            message: '请输入授权码密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
      },
      triallDate: [
        {
          value: 7,
          label: '七天',
        },
        {
          value: 15,
          label: '十五天',
        },
        {
          value: 30,
          label: '一个月',
        },
      ],
      /*产品试用end*/

      /*申请购买产品start*/
      buyFirstDialog: false,
      buyFirstForm: {
        code: '', //产品授权码
        key: '', //产品授权密码
        name: '', //授权客户名称
        contact_name: '', //客户联系人
        phone: '', //联系人手机
        email: '', //联系人邮箱
        user_count: 1, //购买用户数,
        months: 12,
        product: 1,
        edition: '11',
        pay_type: 1,
      },
      buyFirstFormRules: {
        code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        key: [
          {
            required: true,
            message: '请输入授权码密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
        user_count: [{ type: 'number', message: '请输入数字' }],
      },
      buyDate: [
        {
          value: 12,
          label: '一年',
        },
        {
          value: 24,
          label: '两年',
        },
        {
          value: 36,
          label: '三年',
        },
        {
          value: 10000,
          label: '买断',
        },
      ],
      buyDateDict: {
        12: 1,
        24: 2,
        36: 3,
        10000: '买断',
      },
      /*申请购买产品end*/

      /*产品加点start*/
      addPointDialog: false,
      addFastBIDateValue: '',
      addPointForm: {
        code: '', //产品授权码
        key: '', //产品授权密码
        name: '', //授权客户名称
        old_user_count: '', //已购买用户数
        user_count: 1, //新增用户数
        pay_type: 1,
      },
      addPointFormRules: {
        user_count: [
          { required: true, message: '请输入新增用户数', trigger: 'blur' },
          { type: 'number', message: '请输入数字' },
        ],
      },
      /*产品加点end*/

      /*产品续费start*/
      renewDialog: false,
      renewForm: {
        code: '', //产品授权码
        name: '', //授权客户名称
        old_user_count: '', //已购买用户数
        pay_type: 1,
        months: 12,
        old_expire_time: '', // 过期时间
        buy_expire_time: '',
      },
      renewFormRules: {
        months: [
          { required: true, message: '请输入新增用户数', trigger: 'blur' },
          { type: 'number', message: '请输入数字' },
        ],
      },
      /*产品续费end*/

      /*产品修改密码start*/
      changeKeyDialog: false,
      changeFastBIDateValue: '',
      changKeyForm: {
        code: '', //产品授权码
        newPassword: '', //新密码
        rePassword: '', //确认密码
      },
      changKeyFormRules: {
        newPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        rePassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
      },
      /*产品修改密码end*/

      /*编辑授权账号信息start*/
      editCustomerDialog: false,
      editPasswordDialog: false,

      editFastBIDateValue: '',
      editCustomerForm: {
        code: '', //企业授权码
        name: "",   //企业名称
        note: ""   // 备注
      },
      editPasswordForm: {
        code: '', //企业授权码
        name: '', //企业名称
        pass: "", //密码
        checkPass: ""   //密码
      },
      editPasswordFormRules: {
        pass: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePass3,
          },
        ],
        checkPass: [
          {
            required: true,
            trigger: 'blur',
            validator: validatePass4,
          },
        ],
      },
      /*编辑授权账号信息end*/
      /*显示授权证书 start*/
      certificateDialog: false,
      certificateUrl: '',
      certi_attach_url: '',
      /*显示授权证书 end*/
      offlineForm: {
        code: '',
        auth_code: '',
      },
      XZEditions: [],
      updateShow: false,
      activeName: 'first',
      currentOrg: null,
      ordersModulesLoading: false,
      orderListLoading: false,
      tabLoading: false,
      orderList1: [],
      is_superuser: false,

    };
  },
  created() {
  },
  mounted() {
    this.getAuthData();
    this.getUserInfo();

  },
  methods: {
    async getUserInfo() {
      const res = await this.$store.dispatch('user/userinfo');
      this.is_superuser = res.is_superuser;
    },
    /* 授权转移 */
    authorizationTransfer(index, row) {
      this.$refs.transferDialog.show();
      console.log(row);

      this.$refs.transferDialog.initData(row, 'local');
    },
    /* 试用延期 */
    trialExtension(index, row) {
      this.$refs.extensionDialog.show();
      this.$refs.extensionDialog.initData(row, 'list');
    },
    trialAppExtension(index, row) {
      console.log(row)
      this.$refs.extensionDialog.show();
      this.$refs.extensionDialog.initData(row, 'app');
    },
    parseSeriesName(edition) {
      return seriesName[edition];
    },
    parseVersion(grade) {
      return version[grade];
    },
    // 离线授权
    offlineAuth() { },

    triallChange(val) {
      if (val == 11) {
        //标准版
        this.triallForm.user_count = 1;
      } else if (val == 12) {
        //高级版
        this.triallForm.user_count = 100;
      }
    },
    changeEdition(val) {
      if (val == 11) {
        //标准版
        this.buyFirstForm.user_count = 1;
        this.buyFirstForm.months = 12;
      } else if (val == 12) {
        //高级版
        this.buyFirstForm.user_count = 100;
        this.buyFirstForm.months = 10000;
      }
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAuthData();
    },
    handleSizeChange(val) {
      if (val <= this.pagination.total) {
        this.pagination.size = val;
        this.getAuthData();
      }
    },
    handleCurrentChangeOrder(val) {
      this.orderPagination.currentPage = val;
      this.getAuthData();
    },
    handleSizeChangeOrder(val) {
      if (val <= this.orderPagination.total) {
        this.orderPagination.size = val;
        this.getAuthData();
      }
    },
    resetVerifyCodeResult() {
      this.verifyCodeResult.success = false;
      this.verifyCodeResult.loading = false;
      this.verifyCodeResult.icon = '';
    },
    verifyCodeOnInput(val) {
      if (val) {
        this.verifyCodeResult.success = false;
        this.verifyCodeResult.loading = true;
        this.verifyCodeResult.icon = 'el-icon-loading';
        verifyCode({ code: val, product: 1 })
          .then(() => {
            this.verifyCodeResult.success = true;
            this.verifyCodeResult.loading = false;
            this.verifyCodeResult.icon = 'el-icon-success';
          })
          .catch(() => {
            this.verifyCodeResult.icon = 'el-icon-error';
            this.verifyCodeResult.success = false;
            this.verifyCodeResult.loading = false;
          });
      } else {
        this.verifyCodeResult.icon = '';
        this.verifyCodeResult.success = false;
        this.verifyCodeResult.loading = false;
      }
    },
    getOrderList() {
      let params = {
        p: this.orderPagination.currentPage,
        count: this.orderPagination.size,
        af_auth: this.curentId
      };
      let result = createGetUrlParams(params);
      if (result.success) {
        getOrderByParam(result.data).then(res => {
          this.orderList = res.results.map(r => {
            if (r.detail) {
              try {
                let detail = JSON.parse(r.detail)
                let { edition_bill, app_bill } = detail
                r.edition = edition_bill.name
                r.apps = ""
                if (app_bill) {
                  app_bill.apps.forEach((a, index) => {
                    if (index == 0) {
                      r.apps += a.name
                    } else {
                      r.apps += `,${a.name}`
                    }

                  });
                }

              } catch (error) {

              }

            }
            return r
          });
          this.orderPagination.total = res.count;

          this.orderListLoading = false
        }).catch(err => {
          this.orderList1 = []
          this.orderListLoading = false
        })
      } else {
        this.orderListLoading = false
      }
    },
    checkBuyout(dateStr) {
      // Parse input date string (format: YYYY-MM-DD HH:mm:ss)
      const [datePart, timePart] = dateStr.split(' ');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hours, minutes, seconds] = timePart.split(':').map(Number);

      // Create Date objects for comparison
      const targetDate = new Date(year, month - 1, day, hours, minutes, seconds); // Months are 0-based
      const cutoffDate = new Date(2099, 11, 31, 23, 59, 59); // 2099-12-31 23:59:59

      // Validate parsed date
      if (isNaN(targetDate.getTime())) {
        throw new Error(`Invalid date format: ${dateStr}`);
      }

      // Return "买断" if the target date exceeds the cutoff
      return targetDate > cutoffDate ? '买断' : dateStr;
    },
    // 购买查看
    purchaseView(index, row) {
      this.activeName = "first"
      this.curentId = row.id;
      this.currentIndex = index;
      this.currentOrg = row
      this.drawer = true;
      this.ordersModulesLoading = true;
      this.orderListLoading = true
      getAFOrdersApps(this.curentId).then(res => {
        this.ordersModulesLoading = false
        res.forEach(item => {
          item.expire_time = this.checkBuyout(item.expire_time)
        })
        console.log(res);
        
        this.purchasedProjects = res
      }).catch(err => {
        console.log(err);
        
        this.ordersModulesLoading = false
      })
      this.orderPagination.currentPage = 1;
      this.orderPagination.size = 50;
      this.getOrderList()

    },

    refreshAFOrdersApps() {
      getAFOrdersApps(this.curentId).then(res => {
        this.ordersModulesLoading = false
        res.forEach(item => {
          item.expire_time = this.checkBuyout(item.expire_time)
        })
        this.purchasedProjects = res
      }).catch(err => {
        this.ordersModulesLoading = false
      })
    },

    // 产品购买
    buyProduct(index, row) {
      this.curentId = row.id;
      this.currentIndex = index;
      this.currentOrg = row;
      this.$refs.buyDialog.isAdd = 'buy';
      this.$refs.buyDialog.show(row);
    },
    buyProduct1(index, row) {
      const cloneOrg = JSON.parse(JSON.stringify(this.currentOrg))
      cloneOrg.main_apps = row.app_key
      this.$refs.buyDialog.isAdd = 'module_buy';
      this.$refs.buyDialog.show(cloneOrg);
    },
    handleClick(val) {
      this.ordersModulesLoading = true
      setTimeout(() => {
        this.orderList = this.orderList1
        this.ordersModulesLoading = false;
      }, 100);
    },

    getModuleName(module) {
      if (!module) return ""
      // module = JSON.parse(module)
      return module.module_name
    },
    getYears(months) {
      const year = months / 12
      return year ? `${year}年` : ""
    },
    download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },

    search() {
      this.restPage(false);
      let params = {
        date_start: this.searchOption.openingDateStart,
        date_stop: this.searchOption.openingDateEnd,
        code: this.searchOption.code,
        name: this.searchOption.name,
        username: this.searchOption.username,
      };
      let result = createGetUrlParams(params);
      console.log(result);

      if (result.success) {
        this.loading = true;
        getAFLocalList(result.data)
          .then((response) => {
            this.tableData = response.results;
            this.pagination.total = response.count;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    restPage(isUsePagination) {
      this.pagination.use = isUsePagination;
      this.pagination.currentPage = 1;
      this.pagination.size = 20;
    },
    restSearch() {
      for (const key in this.searchOption) {
        if (this.searchOption.hasOwnProperty(key)) {
          this.searchOption[key] = '';
        }
      }
      this.restPage(true);
      this.getAuthData();
    },
    getAuthData() {
      this.loading = true;
      let params = {
        p: this.pagination.currentPage,
        count: this.pagination.size,
        date_start: this.searchOption.openingDateStart,
        date_stop: this.searchOption.openingDateEnd,
        code: this.searchOption.code,
        name: this.searchOption.name,
        username: this.searchOption.username,
      };

      let result = createGetUrlParams(params);
      if (result.success) {
        getAFLocalList(result.data)
          .then((response) => {
            this.loading = false;
            this.pagination.total = response.count | 0;
            this.tableData = response.results;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getAuthStatus(index) {
      return authStatus[index];
    },
    triallDialogOpen() {
      this.$refs.buyDialog.isAdd = 'triall';
      this.$refs.buyDialog.show();
    },
    triallFormSubmit() {
      //申请试用
      this.$refs.triallForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.triallForm.product = 1; //FastBI
          addTrail(this.triallForm)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.getAuthData();
              this.triallDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    restTriallForm(done) {
      if (this.$refs.triallForm) this.$refs.triallForm.resetFields();
      done();
    },
    addPointOpen(index, row) {
      //加点
      this.payTableShow = false;
      this.curentId = row.id;
      this.addPointForm.code = row.code;
      this.addPointForm.key = row.key;
      this.addPointForm.name = row.name;
      this.addPointForm.old_user_count = row.user_count;
      this.addPointDialog = true;
    },
    addPointSubmit() {
      this.$refs.addPointForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            user_count: this.addPointForm.user_count,
            pay_type: this.addPointForm.pay_type,
          };
          addUserPrice(this.curentId, data)
            .then((response) => {
              //获取此次充值的价格
              response.code = this.addPointForm.code;
              this.payTableData[0] = response;
              this.payTableShow = true;

              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  this.loading = false;
                  let finance = {
                    special: this.$store.getters.userInfo.finance.fbi_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.addPointForm.pay_type,
                  };
                  let result = payVerify(parms, finance); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    addPointPay() {
      this.loading = true;
      addUser(this.curentId, this.payData)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getAuthData();
          this.addPointDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restAddPointForm(done) {
      //重置修改密码表单
      if (this.$refs.addPointForm) this.$refs.addPointForm.resetFields();
      done();
    },
    renewOrBuy(index, row) {
      let domain = row.domain ? row.domain.split(',') : [''];
      let internal_domain = row.internal_domain ? row.internal_domain.split(',') : [''];
      this.$refs.buyDialog.isAdd = 'edit';
      this.$refs.buyDialog.auth_ips = domain.map((item) => {
        return { value: item };
      });
      this.$refs.buyDialog.Internal_auth_ips = internal_domain.map((item) => {
        return { value: item };
      });
      this.$refs.buyDialog.show(row);
    },
    renewOpen(index, row) {
      //续费
      console.log(row);
      this.currentEdition = row.edition;
      if (
        this.currentEdition == 'FastBI企业版' ||
        this.currentEdition == 'FastBI高级版' ||
        this.currentEdition == 'FastBI基础版'
      ) {
        this.renewForm.months = 10000;
      }
      this.payTableShow = false;
      this.curentId = row.id;
      this.renewForm.code = row.code;
      this.renewForm.name = row.name;
      this.renewForm.old_user_count = row.user_count;
      this.renewForm.old_expire_time = row.expire_time;
      this.getExpireTime(this.renewForm.months);
      this.renewDialog = true;
    },
    // 计算续费后截止日期
    getExpireTime(value) {
      console.log(value);
      if (this.buyDateDict[value] === '买断') {
        this.renewForm.buy_expire_time = '买断';
        return;
      }
      let dateArr = this.renewForm.old_expire_time.split('-');
      dateArr[0] = Number(dateArr[0]) + this.buyDateDict[value];
      this.renewForm.buy_expire_time = dateArr.join('-');
    },
    isShowDelayBtn(index, row) {
      return new Date(row.expire_time) <= new Date(); //过期时间小于当前时间
    },
    delayClick(index, row) {
      //试用延期
      let self = this;
      this.$confirm('您将对授权码进行延期操作，是否继续进行？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.loading = true;
          AFLocalDelay(row.id)
            .then((response) => {
              self.loading = false;
              self.$message.success('延期成功!');
              self.getAuthData();
            })
            .catch(() => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    renewSubmit() {
      this.$refs.renewForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            months: this.renewForm.months,
            pay_type: this.renewForm.pay_type,
          };
          addMonthPrice(this.curentId, data)
            .then((response) => {
              response.code = this.renewForm.code;
              this.payTableData[0] = response;
              this.payTableShow = true;

              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  let finance = {
                    special: this.$store.getters.userInfo.finance.fbi_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.renewForm.pay_type,
                  };
                  let result = payVerify(parms, finance); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                  this.loading = false;
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    renewPay() {
      this.loading = true;
      addMonth(this.curentId, this.payData)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getAuthData();
          this.renewDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restRenewForm(done) {
      if (this.$refs.renewForm) this.$refs.renewForm.resetFields();
      done();
    },
    changeKeyOpen(index, row) {
      //修改密码
      this.curentId = row.id;
      this.currentIndex = index;
      this.changKeyForm.code = row.code;
      this.changeKeyDialog = true;
    },
    restChangeKeyForm(done) {
      //重置修改密码表单
      if (this.$refs.changKeyForm) this.$refs.changKeyForm.resetFields();
      done();
    },
    editCustomerOpen(index, row) {
      //编辑信息
      this.curentId = row.id;
      this.currentIndex = index;
      this.editCustomerForm.code = row.code;
      this.editCustomerForm.note = row.note;
      this.editCustomerForm.name = row.name
      this.editCustomerDialog = true;
    },
    editPasswordOpen(index, row) {
      this.curentId = row.id;
      this.currentIndex = index;
      this.editPasswordForm.checkPass = "";
      this.editPasswordForm.pass = "";
      this.editPasswordForm.code = row.code;
      this.editPasswordForm.name = row.name
      this.editPasswordDialog = true;
    },
    editCustomerSubmit() {
      this.$refs.editCustomerForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          AFLocalUpdate(this.curentId, { "note": this.editCustomerForm.note })
            .then((response) => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '编辑备注成功',
              });

              this.getAuthData();
              this.editCustomerDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    editPasswordSubmit() {
      this.$refs.editPasswordForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          AFLocalUpdate(this.curentId, { "key": this.editPasswordForm.pass })
            .then((response) => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '修改密钥成功',
              });

              this.getAuthData();
              this.editPasswordDialog = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    restEditCustomerForm(done) {
      if (this.$refs.editCustomerForm) this.$refs.editCustomerForm.resetFields();
      done();
    },
    restEditPasswordForm(done) {
      if (this.$refs.editPasswordForm) this.$refs.editPasswordForm.resetFields();
      done();
    },
    certificateOpen(index, row) {
      //显示授权证书
      this.certificateUrl = '';
      this.certi_attach_url = '';
      this.loading = true;
      getCertificateById(row.id)
        .then((response) => {
          this.certificateUrl = response.url;
          this.certi_attach_url = response.attach_url;
          this.loading = false;
          this.certificateDialog = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    offlineAuthOpen(index, row) {
      this.offlineForm.auth_code = row.code;
      this.offlineForm.code = '';
      this.offlineDialog = true;
    },
    offlineAuthClose() {
      // this.offlineForm = {
      //   code: "",
      //   auth_code: "",
      // };
      this.offlineDialog = false;
    },
    // 申请授权
    applyOffline() {
      this.$confirm(
        `您要进行离线授权的授权码是${this.offlineForm.auth_code
        }，离线授权成功后，该授权码将不再可以进行在线验证，确定进行离线授权么？?`,
        '离线授权',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          setOffline(this.offlineForm)
            .then((res) => {
              console.log(res);
              // this.offlineDialog = true;
              this.offlineAuthClose();

              location.href = res.url;
            })
            .catch((err) => { });
        })
        .catch(() => { });
    },
    buyFirstDialogOpen() {
      this.$refs.buyDialog.isAdd = 'add';
      this.$refs.buyDialog.show();
    },
    buyFirstSubmit() {
      this.$refs.buyFirstForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.buyFirstForm.product = 1; //fastbi
          let data = {
            user_count: this.buyFirstForm.user_count,
            months: this.buyFirstForm.months,
            pay_type: this.buyFirstForm.pay_type,
            product: 1,
            edition: this.buyFirstForm.edition,
          };
          buyPrice(data)
            .then((response) => {
              //获取此次充值的价格
              response.code = this.buyFirstForm.code;
              this.payTableData[0] = response;
              this.payTableShow = true;

              this.$store
                .dispatch('user/userinfo') //获取账户余额
                .then(() => {
                  this.loading = false;
                  let finance = {
                    special: this.$store.getters.userInfo.finance.fbi_point,
                    universal: this.$store.getters.userInfo.finance.point,
                  };
                  let parms = {
                    price: response.price,
                    payType: this.buyFirstForm.pay_type,
                  };
                  let result = payVerify(parms, finance); //检测余额是否足够
                  this.payDescription = result.msg;
                  this.payBtnShow = result.success;

                  if (result.success) {
                    //余额充足
                    this.payData = data;
                    this.alertType = 'success';
                  } else {
                    //余额不足
                    this.alertType = 'error';
                  }
                })
                .catch(() => {
                  this.loading = false;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    firstBuySure() {
      this.loading = true;
      buy(this.buyFirstForm)
        .then((response) => {
          this.loading = false;
          this.$message({
            type: 'success',
            message: '支付成功',
          });
          this.getAuthData();
          this.buyFirstDialog = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restbuyFirstForm(done) {
      if (this.$refs.buyFirstForm) this.$refs.buyFirstForm.resetFields();
      done();
    },
    cancel(formName, close) {
      this.$refs[formName].resetFields();
    },
    parseDate(date) {
      const tempDate = new Date(date);
      if (isNaN(tempDate.getTime())) {
        const year = tempDate.getFullYear();
        if (year >= 2100) return '买断';
        return date;
      }
      return date;
    },


  },
  components: {
    buyDialog,
    transferDialog,
    extensionDialog
  },
};
</script>

<style lang="scss">
@import url('../../assets/css/product.css');

.el-drawer__body {
  height: calc(100% - 40px);
}

.el-drawer__header {
  margin-bottom: 10px;
  padding: 10px 10px 0;
  // height: 40px;
}

.el-tabs {
  height: calc(100% - 40px);
}

.el-tabs__content {
  height: calc(100% - 54px);
}

.el-tab-pane {
  height: 100%;
}


.drawer_main {
  padding: 10px 20px;
  // display: flex;
  // flex-direction: column;
  height: 100%;

  .title_main {
    // flex: 1;
    height: 102px;
    background: #EBEEF5;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 20px;

    .title_top {
      color: #333;

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }

    .title_mid {
      color: #565454;
      display: flex;
      font-size: 14px;
      margin: 10px 0px;
      justify-content: space-between;

      .item {
        display: flex;
        // margin-right: 10px;
      }
    }

    .title_bottom {
      color: #565454;
      font-size: 14px;
    }
  }

  .table_main {
    height: calc(100% - 102px);
  }
}


.af_cloud {
  .main {
    display: flex;
    flex-direction: column;
    margin: 0px 14px;
    height: 100%;
    //background-color: #FFFFFF;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    .main_title {
      margin: 15px 0;
    }

    .product-selector_main {
      display: flex;
      flex-wrap: wrap;
      width: calc(100% - 24px);
      background: #fff;
      padding: 10px 0px 20px 24px;
      min-width: 980px;
      font-size: 12px;

      .selector-item {
        display: flex;
        align-items: center;
        // flex-wrap: wrap;
        margin-right: 20px;
        margin-top: 10px;
        // .title{
        //   width: 90px;
        // }
      }
    }

    .selector-left_main {
      width: calc(100% - 200px);
      height: 100%;
      display: flex;
      flex-wrap: wrap;
    }

    .selector-right_main {
      width: 200px;
      height: 100%;
      display: flex;
      align-items: center;

      .buttons {
        margin-top: 10px;
        height: 32px;
      }
    }

    .product-selector {
      background: #fff;
    }

    .group {
      p {
        margin: 10px 15px 10px 5px !important;
        float: left !important;
        width: 50px !important;
        height: 32px !important;
        line-height: 32px !important;
        text-align: right !important;
      }
    }

    .group .el-input {
      float: left !important;
      margin: 10px 0px !important;
      width: 120px !important;
    }

    .product-main-list {
      flex-grow: 1;
      height: 50%;
    }
  }

  .alert {
    margin-bottom: 10px;
  }

  .pay_btn {
    float: right;
  }
}

.certificate_img_main {
  display: flex;
  padding-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/agileFlow/localProduct.vue